import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/update-duck';

const { Types, Creators } = createActions(
  {
    request: ['id', 'putData', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'UPDATE_GROUP_' }
);

export interface UpdateGroupState extends IState {}

const INITIAL_STATE: UpdateGroupState = {
  loading: false,
  error: null,
};

const request = (state: UpdateGroupState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: UpdateGroupState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: UpdateGroupState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateGroup = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateGroupTypes = Types;
export const UpdateGroupActions = Creators;
